import Vue from 'vue'
import { store } from '../store/index'
import Router from 'vue-router'
import Auth from '@/layouts/Auth'
import Main from '@/layouts/Main'
import ConstructorMain from '@/components/Constructor/index'
import ListDB from '@/components/Constructor/ListDB'
import NewDB from '@/components/Constructor/NewDB'
import EditSchema from '@/components/Constructor/EditSchema'
import EmployeeMain from '@/components/Employees/index'
import EmployeesList from '@/components/Employees/EmployeesList'
import AddEmployee from '../components/Employees/AddEmployee/AddEmployee.vue'
import EditEmployee from '../components/Employees/EditEmployee/EditEmployee.vue'
import DbMain from '@/components/DataBase/index'
import DataBaseList from '@/components/DataBase/DataBaseList'
import AddNewRecord from '@/components/DataBase/AddNewRecord'
import Enter from '../components/EnterPage/EnterPage'
import SmartId from '../components/SmartId/SmartId'
import index from '../components/OrganisationStructure/index'
import OrganisationList from '../components/OrganisationStructure/Organisation/OrganisationList/OrganisationList'
import DivisionList from '../components/OrganisationStructure/Division/DivisionList/DivisionList'
import DivisionItem from '../components/OrganisationStructure/Division/DivisionItem/DivisionItem'
import EditOrganisation from '../components/OrganisationStructure/Organisation/EditOrganisation/EditOrganisation'
import AddDivision from '../components/OrganisationStructure/Division/AddDivision/AddDivision'
import AddPosition from '../components/OrganisationStructure/Position/AddPosition/AddPosition'
import EditPosition from '../components/OrganisationStructure/Position/EditPosition/EditPosition'
import EditDivision from '../components/OrganisationStructure/Division/EditDivision/EditDivision'
import IssueList from '../components/IssueStructure/IssueList/IsuueList'
import Catalog from '../components/Catalog/Catalog.vue'
import IssueItem from '../components/IssueStructure/IssueItem/IssueItem'
import IssueMain from '../components/IssueStructure/index'
import Reports from '../components/Reports/Reports'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'enter',
      component: Enter
    },
    {
      path: '/auth/inn',
      name: 'auth',
      component: Auth
    },
    {
      path: '/auth/smart-id',
      name: 'smart-id',
      component: SmartId
    },
    {
      path: '/main',
      component: Main,
      children: [
        {
          path: '/main',
          redirect: to => {
            let isAdmin = store.state.userInfo.user.isAdmin
            if (isAdmin) return '/main/constructor'
            else return '/main/catalog'
            // if (window.innerWidth < 600)
          }
        },
        {
          path: '/main/constructor',
          component: ConstructorMain,
          children: [
            {
              path: '/main/constructor',
              redirect: { path: 'list' }
            },
            {
              path: 'list',
              name: 'constructor-list',
              component: ListDB,
              beforeEnter: AuthGuard
            },
            {
              path: 'new',
              name: 'constructor-new',
              component: NewDB,
              beforeEnter: AuthGuard
            },
            {
              path: 'edit/:id',
              name: 'constructor-edit',
              props: true,
              component: EditSchema,
              beforeEnter: AuthGuard
            }
          ]
        },
        {
          path: '/main/db',
          component: DbMain,
          children: [
            {
              path: '/main/db',
              redirect: { path: 'list' }
            },
            {
              path: 'list',
              name: 'database-list',
              component: DataBaseList,
              beforeEnter: AuthGuard
            },
            {
              path: 'add/:id',
              name: 'addNote',
              props: true,
              component: AddNewRecord,
              beforeEnter: AuthGuard
            }
          ]
        },
        {
          path: '/main/employee',
          component: EmployeeMain,
          children: [
            {
              path: '/main/employee',
              redirect: { path: 'list' }
            },
            {
              path: 'list',
              name: 'employee-list',
              component: EmployeesList,
              beforeEnter: AuthGuard
            },
            {
              path: '/main/employee/add',
              name: 'add-employee',
              component: AddEmployee,
              beforeEnter: AuthGuard
            },
            {
              path: 'edit/:id',
              name: 'edit-employee',
              props: true,
              component: EditEmployee,
              beforeEnter: AuthGuard
            }
          ]
        },
        {
          path: '/main/organisation',
          component: index,
          children: [
            {
              path: '/main/organisation',
              redirect: { path: 'list' }
            },
            {
              path: 'list',
              name: 'organisation-list',
              component: OrganisationList,
              beforeEnter: AuthGuard
            },
            {
              path: 'edit/:id',
              name: 'edit-organisation',
              component: EditOrganisation,
              props: true,
              beforeEnter: AuthGuard
            },
            {
              path: '/main/organisation/:id',
              name: 'division-list',
              component: DivisionList,
              props: true,
              beforeEnter: AuthGuard
            },
            {
              path: '/main/organisation/division/add',
              name: 'add-division',
              component: AddDivision,
              props: true,
              beforeEnter: AuthGuard
            },
            {
              path: '/main/organisation/division/edit/:id',
              name: 'edit-division',
              component: EditDivision,
              props: true,
              beforeEnter: AuthGuard
            },
            {
              path: '/main/organisation/division/:id',
              name: 'division-item',
              component: DivisionItem,
              props: true,
              beforeEnter: AuthGuard
            },
            {
              path: '/main/organisation/division/position/add',
              name: 'add-position',
              component: AddPosition,
              beforeEnter: AuthGuard
            },
            {
              path: '/main/organisation/division/position/edit/:id',
              name: 'edit-position',
              component: EditPosition,
              props: true,
              beforeEnter: AuthGuard
            }
          ]
        },
        {
          path: '/main/issue',
          name: 'main',
          component: IssueMain,
          children: [
            {
              path: '/main/issue',
              redirect: { path: 'list' }
            },
            {
              path: 'list',
              name: 'issue-list',
              component: IssueList,
              beforeEnter: AuthGuard
            },
            {
              path: 'item/:id',
              name: 'issue-item',
              props: true,
              component: IssueItem,
              beforeEnter: AuthGuard
            }
          ]
        },
        {
          path: '/main/catalog',
          name: 'catalog',
          component: Catalog,
          beforeEnter: AuthGuard
        },
        {
          path: '/main/reports',
          name: 'reports',
          component: Reports,
          beforeEnter: AuthGuard
        }
      ]
    },
    {
      path: '*',
      redirect: { name: '/' }
    }
  ]
})

function AuthGuard(to, from, next) {
  let token = localStorage.getItem('SmartId-SessionId')
  // const auth = store.state.auth.authenticated
  if (token) next()
  else next('/')
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js